import { render, staticRenderFns } from "./summaryAndConclusionBoxes.vue?vue&type=template&id=594a2d92&scoped=true"
import script from "./summaryAndConclusionBoxes.vue?vue&type=script&lang=js"
export * from "./summaryAndConclusionBoxes.vue?vue&type=script&lang=js"
import style0 from "./summaryAndConclusionBoxes.vue?vue&type=style&index=0&id=594a2d92&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "594a2d92",
  null
  
)

export default component.exports